import React, { useState } from "react";
import { Link } from "react-router-dom";
import Servimg01 from "../../../assets/images/shape/services-two-shape-1.png";
import Servimg02 from "../../../assets/images/shape/services-two-shape-2.png";
import Servimg03 from "../../../assets/images/services/caprim-seguridad-pagos.jpg";
import Servimg04 from "../../../assets/images/services/caprim-pagos-transfronterizos.jpg";
import Servimg05 from "../../../assets/images/services/caprim-tesoreria-nube.jpg";

const Servicestwo = () => {
  const [activeTab, setActiveTab] = useState("recaudo-tab");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="services-two">
      <div className="services-two-shape-one-1">
        <img src={Servimg01} alt="shape" />
      </div>
      <div className="services-two-shape-one-2">
        <img src={Servimg02} alt="shape" />
      </div>
      <div className="services-two-inner-bg">
        <div className="container">
          <div className="row align-items-center gutter-y-30 mb-3 mb-lg-0">
            <div className="col-lg-7 col-md-12">
              <div className="heading-box">
                <span className="heading-subtitle wow fadeInUp animated">
                  🤝 BENEFICIOS
                </span>
                <h2 className="heading-title wow fadeInUp animated">
                  Tres formas de mover el dinero de tu empresa
                </h2>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 text-start text-lg-end">
              <Link to="/Contactus" className="btn btn-outline-secondary">
                Contáctanos <i className="flaticon-next" />
              </Link>
            </div>
          </div>
          <ul
            className="nav nav-tabs justify-content-between border-0"
            id="services-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "recaudo-tab" ? "active" : ""
                }`}
                onClick={() => handleTabClick("recaudo-tab")}
                type="button"
                role="tab"
                aria-controls="recaudo-tab-pane"
                aria-selected={activeTab === "recaudo-tab"}
              >
                <i className="flaticon-personal" />
                <span>Dispersión y recaudo de pagos</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "transfronterizos-tab" ? "active" : ""
                }`}
                onClick={() => handleTabClick("transfronterizos-tab")}
                type="button"
                role="tab"
                aria-controls="transfronterizos-tab-pane"
                aria-selected={activeTab === "transfronterizos-tab"}
              >
                <i className="flaticon-money-bag-1" />
                <span>Pagos transfronterizos</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "tesoreria-tab" ? "active" : ""
                }`}
                onClick={() => handleTabClick("tesoreria-tab")}
                type="button"
                role="tab"
                aria-controls="tesoreria-tab-pane"
                aria-selected={activeTab === "tesoreria-tab"}
              >
                <i className="flaticon-real-estate" />
                <span>Tesorería en la nube</span>
                <span className="caprim-tab-proximamente">Próximamente</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="tab-content" id="services-tab-content">
        <div
          className={`tab-pane fade ${
            activeTab === "recaudo-tab" ? "show active" : ""
          }`}
          id="recaudo-tab-pane"
          role="tabpanel"
          aria-labelledby="recaudo-tab"
          tabIndex={0}
        >
          <div className="container">
            <div className="row align-items-start align-items-xl-center gutter-y-30">
              <div className="col-lg-5">
                <div className="services-two-image">
                  <img src={Servimg03} alt="services-image" />
                  <div className="image-shape">
                    <span />
                    <span />
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="services-two-info">
                  <div className="services-two-details">
                    <p>
                      Recibe pagos de tus clientes por llave Bre-B
                      personalizada, link PSE o tarjeta débito/crédito, y paga
                      automáticamente a tus proveedores, empleados o
                      comisionistas. También disponible para personas
                      naturales cuando su negocio lo requiere.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`tab-pane fade ${
            activeTab === "transfronterizos-tab" ? "show active" : ""
          }`}
          id="transfronterizos-tab-pane"
          role="tabpanel"
          aria-labelledby="transfronterizos-tab"
          tabIndex={0}
        >
          <div className="container">
            <div className="row align-items-start align-items-xl-center gutter-y-30">
              <div className="col-lg-5">
                <div className="services-two-image">
                  <img src={Servimg04} alt="services-image" />
                  <div className="image-shape">
                    <span />
                    <span />
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="services-two-info">
                  <div className="services-two-details">
                    <p>
                      Mueve dinero entre Colombia, Estados Unidos y China de
                      forma ágil, pensado para e-commerce, importadores,
                      exportadores y empresas de remesas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`tab-pane fade ${
            activeTab === "tesoreria-tab" ? "show active" : ""
          }`}
          id="tesoreria-tab-pane"
          role="tabpanel"
          aria-labelledby="tesoreria-tab"
          tabIndex={0}
        >
          <div className="container">
            <div className="row align-items-start align-items-xl-center gutter-y-30">
              <div className="col-lg-5">
                <div className="services-two-image">
                  <img src={Servimg05} alt="services-image" />
                  <div className="image-shape">
                    <span />
                    <span />
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="services-two-info">
                  <div className="services-two-details">
                    <p>
                      Estamos construyendo una plataforma donde tu empresa
                      pueda ver y administrar todo su dinero en un solo
                      lugar, sin hojas de cálculo ni múltiples bancos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicestwo;
